module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325506/philosophy01-5f89a74e98b26d69b3647a86e5991710.png";